<template>
	<div>
		<div v-if="loading" class="col-sm-12">
			<el-empty description="加载中...">
				<img slot="image" src="@/assets/logo.png" class="brand-image img-circle elevation-3"
					style="width: 32px;opacity: .8">
			</el-empty>
		</div>
		<table ref="table" class="table table-bordered table-hover" v-else>
			<thead>
				<tr>
					<th v-for="item in data.columns" :key="item">{{ labelMap(item) }}</th>
				</tr>
			</thead>
<!--			<tr>-->
<!--				<th v-for="item in data.columns" :key="item">{{ labelMap(item) }}</th>-->
<!--			</tr>-->
			<tbody>
				<tr v-for="(item, index) in data.rows" :key="index">
					<td v-for="column in data.columns" :key="column">{{ item[column] }}</td>
				</tr>
			</tbody>
			<tfoot>
				<tr>
					<th v-for="item in data.columns" :key="item">{{ labelMap(item) }}</th>
				</tr>
			</tfoot>
		</table>
	</div>
</template>

<script>
	import $ from 'jquery'

	export default {
		name: 've-table',
		props: {
			data: {
				type: Object
			},
			settings: {
				type: Object
			}
		},
		data() {
			return {
				loading: true,
				id: undefined,
			}
		},
		watch:{
			// data:function () {
			// 	$(this.$refs.table).DataTable()
			// 	this.$nextTick(() => {
			// 		setInterval(() => {
			// 			this.loading = false
			// 			$(this.$refs.table).DataTable()
			// 		}, 2000)
			// 	})
			// }
		},
		mounted() {
			this.loading = true
      if ( $.fn.dataTable.isDataTable( this.$refs.table ) ) {
        $(this.$refs.table).DataTable({
          paging: true
        })
      }
      else {
        $(this.$refs.table).DataTable( {
          ordering:  false
        });
      }
			this.$nextTick(() => {
				setInterval(() => {
          if ( $.fn.dataTable.isDataTable( this.$refs.table ) ) {
            $(this.$refs.table).DataTable()
          }
          else {
            $(this.$refs.table).DataTable( {
              ordering:  false
            });
          }
					this.loading = false
				}, 2500)
			})
		},
		computed: {
			labelMap() {
				return (key) => {
					return this.settings.labelMap[key]
				}
			},
		}
	}
</script>
